/**
 * English translations - aggregates all namespaces
 */

import common from './common.json';
import auth from './auth.json';
import chat from './chat.json';
import home from './home.json';
import tasks from './tasks.json';
import learning from './learning.json';
import profile from './profile.json';
import errors from './errors.json';
import sidebar from './sidebar.json';

export const en = {
  common,
  auth,
  chat,
  home,
  tasks,
  learning,
  profile,
  errors,
  sidebar,
};

export default en;

